













































import { defineComponent, computed } from '@vue/composition-api';
import store from '@/app/store';
import NavigationMenu from './NavigationMenu.vue';
import { useRoute } from '@/app/composable/router';

export default defineComponent({
    name: 'BaseLayout',
    components: {
        NavigationMenu,
    },
    setup(props, { root }) {
        const isAuthenticated = computed(() => store.getters.auth.isAuthenticated);
        const currentRoute = useRoute();

        // remove hash added by the keyclock authentication to the uri
        if (
            document.location.hash.length > 0 &&
            document.location.hash.match(/^#.*code=[a-zA-Z0-9]*/g) &&
            isAuthenticated
        ) {
            root.$router.push({ ...(currentRoute as any), hash: '' });
        }

        return { isAuthenticated };
    },
});
